/**
 * Canonical key shape for every tenant-owned React Query entry.
 *
 * Keeping tenantId in position 1 makes both exact writes and tenant-scoped
 * prefix invalidation predictable: [scope, tenantId, ...details].
 */
export const tenantQueryKey = <Parts extends readonly unknown[]>(
  scope: string,
  tenantId: string,
  ...parts: Parts
) => [scope, tenantId, ...parts] as const;

export const tenantQueryPrefix = (scope: string, tenantId: string) =>
  tenantQueryKey(scope, tenantId);
